module.exports = __webpack_public_path__ + "img/icom5.7b36c744.png";